import PropTypes from "prop-types";
import styles from "./index.css";
import classnames from "classnames";
import useAdvert from "./useAdvert";

const Advert = ({ className }) => {
  const id = useAdvert();

  return <div id={id} className={classnames(styles.advert, className)} />;
};

Advert.propTypes = {
  className: PropTypes.string,
  hidden: PropTypes.bool
};

export default Advert;
